import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuests } from '../context/QuestContext';
import { useGameFabPulse } from '../hooks/useGameFabPulse';
import { pendingRuhVideos, useRewardedAds } from '../utils/rewardedAds';
import { tl } from '../utils/inlineI18n';
import './GameFab.css';

const PROMO_EVERY_MS = 45000;
const PROMO_VISIBLE_MS = 6000;

const QuestButton = ({ username }) => {
  const { t } = useTranslation('gameData');
  const { openQuests, activeCount, refreshQuests } = useQuests();
  const pulse = useGameFabPulse();
  const title = t('questPanelTitle');
  // Bugün izlenmemiş ödüllü video varsa görev düğmesi yanıp söner, arada solunda
  // "Ücretsiz Ruh Parası kazan" balonu çıkar.
  const ads = useRewardedAds();
  const pendingVideos = pendingRuhVideos(ads);
  const [promoVisible, setPromoVisible] = useState(false);
  useEffect(() => {
    if (pendingVideos <= 0) {
      setPromoVisible(false);
      return undefined;
    }
    let hideTimer = null;
    const show = () => {
      setPromoVisible(true);
      hideTimer = setTimeout(() => setPromoVisible(false), PROMO_VISIBLE_MS);
    };
    const first = setTimeout(show, 3000);
    const id = setInterval(show, PROMO_EVERY_MS);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(id);
    };
  }, [pendingVideos]);

  useEffect(() => {
    if (!username) return;
    refreshQuests(username);
    const id = setInterval(() => refreshQuests(username), 30000);
    return () => clearInterval(id);
  }, [username, refreshQuests]);

  if (!username) return null;

  return (
    <div className="game-fab-slot game-fab-slot--right">
    {promoVisible ? (
      <button
        type="button"
        className="game-fab-promo"
        onClick={() => { setPromoVisible(false); openQuests('level'); }}
      >
        <img src="/image/market/ruh_parasi.png" alt="" className="game-fab-promo__icon" draggable={false} />
        <span>{tl('Ücretsiz Ruh Parası kazan', 'Earn free Soul Coins')}</span>
      </button>
    ) : null}
    <button
      type="button"
      className={`game-fab game-fab--right${activeCount > 0 ? ' game-fab--has-quests' : ''}${pulse ? ' game-fab-pulse' : ''}${pendingVideos > 0 ? ' game-fab--video-pending' : ''}`}
      onClick={() => openQuests(pendingVideos > 0 && activeCount === 0 ? 'level' : undefined)}
      aria-label={title}
      title={title}
    >
      <img src="/image/menu/gorevler.png" alt="" className="game-fab__icon" draggable={false} />
      {activeCount > 0 ? (
        <span className="game-fab__badge">{activeCount > 99 ? '99+' : activeCount}</span>
      ) : null}
    </button>
    </div>
  );
};

export default QuestButton;
